export default __webpack_public_path__ + "static/media/Illust7-setting.63f39b66.jpg";